import PaymentMethodSwitch from './PaymentMethodSwitch'

export default PaymentMethodSwitch
